import { createComponent } from '@carvana/merch-components';

export const Wrapper = createComponent('div', {
  className:
    'mb-24 flex w-full flex-col text-blue-6 tl-header-xs m:mb-32 m:tl-header-s'
});

export const InnerWrapper = createComponent('div', {
  className: 'flex w-full flex-row justify-between'
});

export const Link = createComponent('p', {
  className:
    'text-sm-right whitespace-pre text-center font-normal text-blue-2 underline tl-link-s'
});

export const Text = createComponent('span', {
  className: 'font-normal'
});
